<template>
<a-select
    show-search
    :filter-option="filterOption"
    :show-arrow='false'
    label-in-value
    :value="selected"
    :placeholder="placeholder"
    :not-found-content="loading ? undefined : '请输入片区名称进行搜索'"
    @search="getOrgList"
    @change="handleChange"
    :disabled="disabled"
    :allow-clear='allowClear'
>
    <a-spin v-if="loading" slot="notFoundContent" size="small" />
    <a-select-option v-for="item of orgList" :key="item.id" :title="`运营商：${ item.operator_name }`">{{ item.name }}</a-select-option>
</a-select>
</template>

<script>
import Core from '../../core';

let lastTime = Date.now()
export default {
    name: 'SelectOrgByName',
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        value: {},
        disabled: {},

        operatorId: { type: [Number, String] },

        allowClear: { type: Boolean, default: true, },
        placeholder: { type: String, default: '请选择片区', },
    },
    data() {
        return {
            loading: false,
            orgList: [],

            selected: undefined,
        };
    },
    watch: {
        value: {
            immediate: true,
            handler(n) {
                console.log('SelectOrgByName watch value:', n)
                if (!n) {
                    this.selected = undefined
                }
            }
        },
        'operatorId': {
            immediate: true,
            handler(n) {
                console.log('SelectOrgByName watch operatorId:', n)
                if (!n) {
                    this.selected = undefined
                }
            }
        },
    },
    computed: {
    },
    methods: {
        getOrgList(name, flag_search = false) {
            // 节流
            if (this.orgList.length) {
                let nowTime = Date.now()
                if (nowTime - lastTime < 500) {return}
                lastTime = nowTime
            }

            if (!name && !flag_search) { return }

            if (this.loading) { return }
            this.loading = true

            let params = {
                page_size: 100,
                name: name,
                operator_id: this.operatorId || undefined,
            }
            Core.Api.Org.listByName(params).then(res => {
                console.log('getOrgList params:', params, 'res:', res);
                this.orgList = res.org_list
            }).finally(() => {
                this.loading = false
            })
        },

        filterOption(inputValue, option) {
            let name = option.componentOptions.children[0].text || ''
            return name.includes(inputValue)
        },
        // 选择
        handleChange(value = {}) {
            console.log('SelectOrgByName handleChange value:', value)
            this.selected = value
            this.loading = false
            this.orgList = []

            this.$emit('update', value.key)
            this.$emit('change', value.key)
        },
    },
};
</script>
